module.exports = __webpack_public_path__ + "img/help-round-icon.d169bd45.svg";